import { render, staticRenderFns } from "./UnitTypeSelector.vue?vue&type=template&id=f8860de6&scoped=true&"
import script from "./UnitTypeSelector.vue?vue&type=script&lang=js&"
export * from "./UnitTypeSelector.vue?vue&type=script&lang=js&"
import style0 from "./UnitTypeSelector.vue?vue&type=style&index=0&id=f8860de6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8860de6",
  null
  
)

export default component.exports